<template>
    <div class="animated fadeIn h-100 admin-container">
        <div class="page-content">
            <div class="d-flex content-action align-items-center">
                <div class="input-group border-bottom position-relative" style="width: 190px">
                    <input
                        class="form-control bg-transparent border-none pr-4"
                        :placeholder="$t('common.search')"
                        aria-label="Search"
                        v-model="searchKeyword"
                        style="min-width: 190px"
                    />
                    <i
                        class="fa fa-search position-absolute"
                        style="top: 50%; right: 4px; margin-top: -6px"
                    />
                </div>
                <div class="mx-3 font-20">|</div>
                <div class="d-flex align-items-center text-nowrap">
                    <b-button variant="outline-primary" @click="openCreateModal">
                        <i class="fa fa-plus-circle mr-2"></i>
                        <span class="text-uppercase">Tạo mới</span>
                    </b-button>
                </div>
            </div>
            <b-table
                class="mt-2"
                striped
                hover
                :items="listData"
                :fields="fields"
                show-empty
                :filter="searchKeyword"
                :filter-included-fields="['name']"
            >
                <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>
                <template v-slot:cell(path)="data">{{ data.value.split('/')[1] }}</template>
                <template v-slot:cell(createdAt)="data">
                    <span>{{ data.value | formatDateTime }}</span>
                </template>
                <template v-slot:cell(actions)="row">
                    <b-button
                        variant="primary"
                        class="mr-1 min-width-none"
                        @click="openEditModal(row.item)"
                        v-b-tooltip.hover
                        :title="$t('common.edit')"
                    >
                        <i class="fa fa-pencil"></i>
                    </b-button>
                    <b-button
                        variant="danger"
                        @click="confirmDelete(row.item)"
                        v-b-tooltip.hover
                        class="min-width-none"
                        :title="$t('common.delete')"
                    >
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>
                <template v-slot:empty>
                    <div class="text-center">
                        <span>Không có dữ liệu</span>
                    </div>
                </template>
            </b-table>
        </div>

        <b-modal
            ref="createOrUpdateModal"
            :title="`${form.id ? $t('common.update') : $t('common.create')}`"
            ok-title="Lưu"
            size="lg"
            @ok="handleCreateOk"
            :cancel-title="$t('common.cancel')"
        >
            <b-form-group label="Tên">
                <b-form-input
                    maxlength="255"
                    v-model="form.name"
                    v-validate="'required'"
                    placeholder="Tên"
                    name="name"
                    data-vv-as="Tên"
                ></b-form-input>
                <div v-show="errors.has('name')" class="validation-message text-danger">
                    {{ errors.first('name') }}
                </div>
            </b-form-group>
            <b-form-group label="Tệp tin">
                <b-form-file
                    v-model="file"
                    name="file"
                    placeholder="Chọn tệp tin"
                    drop-placeholder="Kéo tệp tin vào đây"
                ></b-form-file>
                <div v-if="form.path">
                    Tệp tin đã chọn: <b>{{ form.path }}</b>
                    <b-button variant="link" class="text-danger" @click="form.path = null"
                        >Xoá</b-button
                    >
                </div>
            </b-form-group>
        </b-modal>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    async mounted() {
        await this.$nextTick();
        this.listData = await this.getList();
    },
    data: function() {
        return {
            fields: [
                { tdClass: 'align-middle', key: 'index', label: '#' },
                {
                    tdClass: 'align-middle',
                    thClass: 'fixed-actions-col',
                    key: 'name',
                    label: 'Tên'
                },
                {
                    tdClass: 'align-middle',
                    thClass: 'fixed-actions-col',
                    key: 'path',
                    label: 'Tệp tin'
                },
                {
                    tdClass: 'align-middle',
                    key: 'createdAt',
                    label: this.$i18n.t('common.lastCreated')
                },
                {
                    thClass: 'fixed-actions-col',
                    key: 'actions',
                    label: this.$i18n.t('common.actions'),
                    thStyle: { width: '100px' }
                }
            ],
            form: {
                name: null,
                path: null
            },
            searchKeyword: null,
            listData: [],
            data: null,
            file: null
        };
    },
    methods: {
        ...mapActions({
            getList: 'tool/getList',
            create: 'tool/create',
            delete: 'tool/delete',
            update: 'tool/update',
            upload: 'file/upload',
            download: 'file/download',
            createAuditByUser: 'user/createAuditByUser'
        }),
        handleCreateOk(modal) {
            modal.preventDefault();
            this.onSubmit();
        },
        onSubmit() {
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.submitForm();
                }
            });
        },
        async openEditModal(item) {
            this.resetForm();
            this.form = { ...item };
            this.$refs.createOrUpdateModal.show();
        },
        openCreateModal() {
            this.resetForm();
            this.$refs.createOrUpdateModal.show();
        },
        async confirmDelete(item) {
            const result = await this.$bvModal.msgBoxConfirm('Bạn có chắc chắn muốn xoá không?', {
                title: 'Xác nhận',
                okVariant: 'danger',
                okTitle: 'Có',
                cancelTitle: 'Không'
            });
            if (result) {
                await this.delete(item);
                this.listData = await this.getList();
                this.$toaster.success('Xoá thành công');
                this.createAuditByUser({ content: 'Xoá công cụ' });
            }
        },
        resetForm() {
            this.form = {};
        },
        async submitForm() {
            if (this.file) {
                const data = await this.upload({ formData: { file: this.file } });
                this.form.path = data.path;
            }
            if (this.form.id) {
                await this.update(this.form);
            } else {
                await this.create(this.form);
            }
            this.$toaster.success('Thành công');
            this.createAuditByUser({ content: 'Cập nhật công cụ' });
            this.file = null;
            this.listData = await this.getList();
            this.$refs.createOrUpdateModal.hide();
        }
    }
};
</script>
